import React, { useEffect, useState } from 'react';
import { Form, Input, Select, Row, Col } from 'antd';
import DateHelper from '../helpers/DateHelper';
import ValidatorHelper from '../helpers/ValidatorHelper';
import BirthdateInput from '../shared/BirthdateInput';
import StringHelper from '../helpers/StringHelper';
// import UserServices from '../../services/UserServices';
import { usePersistedStore } from '../../store/persisted-store';

export default function PaidForm({ onSubmit }) {


    const { postAgentWagePaid, users: usersState, business, FILTERED_ITEM, FILTER_USERS, GET_ALL_USERS } = usePersistedStore()

    const [form] = Form.useForm();

    // const users = usersState.data;
    const promoters = usersState.promoters;
    // const usersLoading = usersState.loading;
    const token = business.currentBusiness.token;
    // const filteredItem = usersState.filteredItem;
    // const usersData = usersState.data;


    useEffect(() => {
        if (token) {
            form.resetFields();
        }
    }, [token])

    // useEffect(() => {
    //     // dispatch(getUsers());
    //     UserServices.getAllUsers(token).then((res) => {

    //         GET_ALL_USERS(res.data)
    //         filterUsers(filteredItem)
    //     }).catch((error) => {

    //     })
    // }, []);


    // function filterUsers(value) {
    //     const payload = usersData.filter(item => {
    //         return (item.DisplayName && item.DisplayName.includes(value)) ||
    //             (item.Username && item.Username.includes(value));
    //     });
    //     FILTERED_ITEM(value)
    //     FILTER_USERS(payload)
    // }

    function handleChange(e) {
        const promotersRecord = promoters.filter(record => record.Id === e)[0]
        const iban = promotersRecord?.IBAN;
        form.setFieldsValue({
            AccountNumber: iban ? iban : ""
        })
    }


    function onFinish(values) {


        const params = {
            UserName: values.UserName,
            AccountNumber: values.AccountNumber,
            MobileNumber: values.MobileNumber,
            Amount: StringHelper.currencyDeformat(values.Amount),
            RequestCheckoutPaymentCode: values.RequestCheckoutPaymentCode,
            PayDate: values.PayDate && DateHelper.objToDate(values.PayDate),
            Description: values.Description
        };

        postAgentWagePaid({ params: params, cb: onSubmit });
        form.resetFields();
    };

    const formLayout = {
        labelCol: {
            lg: 6,
            xs: 24
        },
        wrapperCol: {
            lg: 16,
            xs: 24
        }
    }
    const itemLayout = {
        lg: 12,
        md: 12,
        sm: 24,
        xs: 24
    }
    const descriptionLayout = {
        labelCol: {
            lg: 3,
            md: 3,
            sm: 24,
            xs: 24
        },
        wrapperCol: {
            lg: 21,
            md: 21,
            sm: 24,
            xs: 24
        }
    }
    return (
        <Form
            form={form}
            name="paid-form"
            className='business-form'
            {...formLayout}
            onFinish={onFinish}
        >
            <Row>
                <Col {...itemLayout}>
                    <Form.Item
                        rules={ValidatorHelper.required('نام کاربری')}
                        name="UserName"
                        label="نام کاربری">
                        <Select
                            onChange={handleChange}
                            showSearch
                            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                            loading={!promoters.length }
                            disabled={!promoters.length}
                            style={{ minWidth: 200 }}
                        >
                            {promoters && promoters.map((name, index) => {
                                return <Select.Option key={index} value={name.Id}>{name.UserName}</Select.Option>
                            })}
                        </Select>
                    </Form.Item>
                </Col>
                <Col {...itemLayout}>

                    <Form.Item
                        rules={ValidatorHelper.accountNumber("شماره شبا")}
                        name="AccountNumber"
                        label="شماره شبا">
                        <Input maxLength={26} disabled={!promoters.length} />
                    </Form.Item>

                </Col>
                <Col {...itemLayout}>
                    <Form.Item
                        rules={ValidatorHelper.mobile()}
                        name="MobileNumber"
                        label="شماره موبایل">
                        <Input maxLength={11} />
                    </Form.Item>
                </Col>
                <Col {...itemLayout}>
                    <Form.Item
                        rules={ValidatorHelper.price('مبلغ')}
                        name="Amount"
                        label="مبلغ">
                        <Input />
                    </Form.Item>
                </Col>
                <Col {...itemLayout}>
                    <Form.Item
                        rules={ValidatorHelper.required('کد پرداخت')}
                        name="RequestCheckoutPaymentCode"
                        label="کد پرداخت">
                        <Input />
                    </Form.Item>
                </Col>
                <Col {...itemLayout}>
                    <Form.Item
                        rules={ValidatorHelper.required('تاریخ واریز')}
                        name="PayDate"
                        label="تاریخ واریز">
                        <BirthdateInput placeholder="تاریخ واریز" />
                    </Form.Item>
                </Col>
                <Col span={23}>
                    <Form.Item
                        {...descriptionLayout}
                        name="Description"
                        label="توضیحات">
                        <Input.TextArea rows={5} placeholder="توضیحات..." />
                    </Form.Item>
                </Col>
            </Row>
            <button type="primary" className="btn btn-primary waves-effect waves-light" htmltype="submit" style={{ width: "100%" }}>
                <i className="bx bx-check-double font-size-14 align-middle"></i>ثبت
            </button>
        </Form>
    )
}
